export default String.raw`
.notfound {
    &-container {
        display: block;
        max-width: 1400px;
        margin: auto;
    }

    &-image {
        display: block;
        margin: 130px auto 50px;
        max-width: 650px;
        width: auto;
        height: auto;
    }

    &-svgMainColor {
        fill: $primaryColor;
    }
    
    &-text {
        margin: 0 auto 80px;
        max-width: 350px;
    }

    &-header {
        display: block;
        margin: 0 auto 30px;
        font-size: 36px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: $primaryColorFont;
    }
    
    &-info {
        display: block;
        margin: 0 auto 25px;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: $primaryColorFont;
    }

    &-button {
        display: block;
        min-width: 250px;
        margin: 25px auto 0;
        padding: 13px 15px;
        text-transform: uppercase;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.71 !important;
        letter-spacing: 1.2px;
        text-align: center;
    }

    @media screen and (max-width: 767px) {
        &-image {
            max-width: 80%;
            margin-top: 80px;
        }

        &-text {
            max-width: 80%;
        }

        &-header {
            font-size: 24px;
        }

        &-info {
            font-size: 14px;
        }

        &-button {
            min-width: calc(100% - 30px);
        }
    }
}
`